// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"89":"forgot","535":"login","966":"dashboard"}[chunkId] || chunkId) + "." + {"88":"8c1fb275","89":"7a7239d9","535":"e6681f79","966":"19e42b8c"}[chunkId] + ".js";
};